/** События аналитики: волны и герои. */
import { z } from "zod";
import { HeroId, PosInt, UInt } from "../common";
import { WaveOutcome } from "../wave-log";

export const wavesEvents = [
  /** Первая пройденная волна у игрока. */
  z.object({ name: z.literal("first_wave"), props: z.object({ seconds: UInt }) }),
  /** Первый проигрыш у игрока. */
  z.object({ name: z.literal("first_defeat"), props: z.object({ wave: PosInt }) }),
  /** Первый убитый босс. */
  z.object({ name: z.literal("first_boss"), props: z.object({ wave: PosInt }) }),
  /** Веха воронки: впервые пройдена волна 5 / 20. */
  z.object({ name: z.literal("wave_5"), props: z.object({}) }),
  z.object({ name: z.literal("wave_20"), props: z.object({}) }),
  /** Волна окончена. `seconds` — игровое время волны, `sessionSeconds` — сколько игрок на экране в этой сессии. */
  z.object({
    name: z.literal("wave_end"),
    props: z.object({ wave: PosInt, result: WaveOutcome, seconds: UInt, sessionSeconds: UInt }),
  }),
  /** Посылка открыта тапом: что в ней было и сколько секунд реального времени ждала. */
  z.object({
    name: z.literal("parcel_tap"),
    props: z.object({ wave: PosInt, reward: z.enum(["coins", "boost"]), seconds: UInt }),
  }),
  /** Посылка исчезла без тапа. */
  z.object({ name: z.literal("parcel_missed"), props: z.object({ wave: PosInt }) }),
  /** Открыт новый герой. */
  z.object({ name: z.literal("hero_unlocked"), props: z.object({ heroId: HeroId, wave: PosInt }) }),
] as const;
